import Vue from 'vue'

const debounce = {
  install(Vue) {
    Vue.directive('debounce', {
      inserted: function(el, binding) {
        el.addEventListener('click', () => {
          if (el.style['pointer-events'] != 'none') {
            el.style['pointer-events'] = 'none';
            setTimeout(() => {
              el.style['pointer-events'] = 'all';
            }, binding.value || 1000)
          }
        })
      }
    })
  }
}

const tool = {
  debounce
}
export default tool;



// WEBPACK FOOTER //
// ./src/utils/debounce.js